import * as chance from '@suntex.core/chance';
import * as math from '@suntex.core/math';

import * as arrays from './arrays';
import * as graphics from './graphics';
import * as load from './load';
import * as test from './test';
import * as text from './text';
import * as ui from './ui';

export type { AlgebraicExpression, Fraction, Numeric } from '@suntex.core/math';

export const ArrayUtil = arrays;
export const Calculator = math;
export const Chance = chance;
export const GraphicsUtil = graphics;
export const LoadUtil = load;
export const TestUtil = test;
export const TextUtil = text;
export const UIUtil = ui;

export { Timer } from './timer';

export {
  AnimationCanvas,
  type AnimationCanvasProps,
} from './react/AnimationCanvas';

export type { PropertyPath, PropertyAtPath } from './arrays';
export type { TargettedEvent, ToggleButton } from './ui';
export type { Sprite } from './graphics';
